<template>
    <comp-4-goal-blurbs :section="12" :page="9" :blurbs="goalBlurbs"></comp-4-goal-blurbs>
</template>

<script>
import { get } from 'vuex-pathify';

export default {
    computed: {
        goalBlurbs: get('section12/goalBlurbs')
    }
};
</script>
